<template>
    <div class="homeEcharts">
        <div id="myChartItem"></div>
        <!-- <div id="googlePublic" style="width:55.3%;height:100%;float: left; margin-right: 0.7%;"></div> -->
        <div class="echarts-left">
          <div class="backColor">
            <div id="DeviceChart">
            </div>
            <div class="left-ztbl">农机状态作业比例分布（累计数据）</div>
          </div>
          <div class="backColorbotom">
            <div class="left-ztbl">预警农机（累计数据）</div>
            <div id="WarningChart"></div>
            <div class="left-yjmj">预警面积︵<br/>亩<br/>︶</div>
          </div>
        </div>
    </div>
</template>

<script>
	import Tmap from '../../../map/js/fzTianmap'
  import "echarts/map/js/china.js"
  import  cityMap from'/static/city.js'
  import  Api from '../../../Serves/net-api.js'
  import Http from '../../../Serves/net-http.js'
  //引入省会列表，测试返回按键
  import ChianData from 'echarts/map/json/china.json'
  import {mapState,mapActions,mapMutations,mapGetters} from "vuex";
  import provinces from './city.js'
  //34个省、市、自治区的名字编码映射数组
  // var provinces = {
  //   //23个省
  //   "台湾": "taiwan",
  //   "河北": 13,
  //   "山西": 14,
  //   "辽宁": 21,
  //   "吉林": 22,
  //   "黑龙江": 23,
  //   "江苏": 32,
  //   "浙江": 33,
  //   "安徽": 34,
  //   "福建": 35,
  //   "江西": 36,
  //   "山东": 37,
  //   "河南": 41,
  //   "湖北": 42,
  //   "湖南": 43,
  //   "广东": 44,
  //   "海南": 46,
  //   "四川": 51,
  //   "贵州": 52,
  //   "云南": 53,
  //   "陕西": 61,
  //   "甘肃": 62,
  //   "青海": 63,
  //   //5个自治区
  //   "新疆生产建设兵团": 65,
  //   "广西": 45,
  //   "内蒙古": 15,
  //   "宁夏回族自治区": 64,
  //   "西藏": 54,
  //   //4个直辖市
  //   "北京": 11,
  //   "天津": 12,
  //   "上海": 31,
  //   "重庆": 50,
  //   "青岛": 370200000000,
  //   "济南": 370100,
  //   //2个特别行政区
  //   "香港": "xianggang",
  //   "澳门": "aomen",
  //   "全国": 'china'
  // };
  // var provinces = {
  //   //23个省
  //   "台湾": "taiwan",
  //   "河北省": 13,
  //   '石家庄市': 130100,
  //   '沧州市': 130900,
  //   '唐山市': 130200,
  //   '秦皇岛市': 130300,
  //   '邯郸市': 130400,
  //   '邢台市': 130500,
  //   '保定市': 130600,
  //   '张家口市': 130700,
  //   '承德市': 130800,
  //   '沧州市': 130900,
  //   '廊坊市': 131000,
  //   '衡水市': 131100,
  //   "山西省": 14,
  //   "辽宁省": 21,
  //   "吉林省": 22,
  //   "黑龙江省": 23,
  //   "江苏省": 32,
  //   "浙江省": 33,
  //   "安徽省": 34,
  //   "福建省": 35,
  //   "江西省": 36,
  //   "山东省": 37,
  //   "河南省": 41,
  //   "湖北省": 42,
  //   "湖南省": 43,
  //   "广东省": 44,
  //   "海南省": 46,
  //   "四川省": 51,
  //   "贵州省": 52,
  //   "云南省": 53,
  //   "陕西省": 61,
  //   "甘肃省": 62,
  //   "青海省": 63,
  //   //5个自治区
  //   "新疆生产建设兵团": 71,
  //   "新疆维吾尔自治区": 71,
  //   "广西壮族自治区": 45,
  //   "内蒙古自治区": 15,
  //   "宁夏回族自治区": 64,
  //   "西藏自治区": 54,
  //   //4个直辖市
  //   "北京市": 11,
  //   "天津市": 12,
  //   "上海市": 31,
  //   "重庆市": 50,
  //   "青岛市": 370200000000,
  //   "济南市": 370100,
  //   //2个特别行政区
  //   "香港": "xianggang",
  //   "澳门": "aomen",
  //   "全国": 'china'
  // };
  //直辖市和特别行政区-只有二级地图，没有三级地图
  var special = ["北京市","天津市","上海市","重庆市","香港","澳门",'青岛市','济南市']
  var mapdata = [];
  export default {
    name:'Eachars',
    data(){
      return{
        myChart:'',
        mydata:[],
        statue:1,
        //环形数据
        DeviceChart:'',
        WarningChart:'',
        taskAgrMonTotal:'',//作业机器
        freeAgrMonTotal:'',//空闲机器
        allNumb:'',//换状图初始值
        propsState:'',//传来的首页状态
        WarData:[],//预警条形图初始值
        WarningSetData:[],//作业预警农机阶段亩数设置
        Code:'',
        Index:'',
        cityName:'',
        level_1:'',level_2:'',level_3:'',level_4:'',
        Tmap: new Tmap(),
        countyCodes: '',
        data:
          [
            {
              name: "北京市",
              value: 500
            },
            {
              name: "福建省",
              value: 500
            },
            {
              name: "江西省",
              value: 400
            },
            {
              name: "山东省",
              value: 500
            },
            {
              name: "天津市",
              value: 300
            },
            {
              name: "河北省",
              value: 600
            },
            {
              name: "山西省",
              value: 650
            },
            {
              name: "河南省",
              value: 600
            },
            {
              name: "湖北省",
              value: 450
            },
            {
              name: "重庆市",
              value: 380
            },
            {
              name: "四川省",
              value: 300
            },
            {
              name: "陕西省",
              value: 250
            },
            {
              name: "甘肃省",
              value: 230
            },
            {
              name: "辽宁省",
              value: 200
            },
            {
              name: "吉林省",
              value: 190
            },
            {
              name: "黑龙江省",
              value: 180
            },
            {
              name: "江苏省",
              value: 170
            },
            {
              name: "浙江省",
              value: 360
            },
            {
              name: "安徽省",
              value: 450
            },
            {
              name: "贵州省",
              value: 320
            },
            {
              name: "云南省",
              value: 400
            },
            {
              name: "西藏自治区",
              value: 400
            },
            {
              name: "青海省",
              value: 400
            },
            {
              name: "宁夏",
              value: 400
            }
          ]
      }
    },
    computed: {
      dataList() {
        return this.$store.state.info
      },
      // mapData(){
      //   return this.$store.state.mapData
      // },
      // ...mapState(['mapData']),
      // ...mapGetters(['mapData'])
    },
    watch: {
      // ...mapGetters(['mapData']),
      // mapData(val){
      //   console.log(val)
      // }
    },
    created () {
      
    },
    mounted(){
      this.Code=this.$store.state.Code
      this.Index=this.$store.state.Index
        if (this.$store.state.info.provCode === '11') {
          var data = {
            provCode: this.$store.state.info.provCode
          }
        } else {
          var data = {
            countyCode: this.$store.state.Code
          }
        }
        this.WarData=[];
        var url=Http.test+'/applicationSubsidy/countWarnNjNum'
        Api.doPost(url,null,false,(res)=>{
          if (this.$store.state.info.provCode === '11') {
            var param = {
              name: this.$store.state.info.provName
            }
          } else {
            var param = {
              name: this.$store.state.info.areaName
            }
          }
          this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
          Api.doGet('/static/geometryProvince/'+provinces[param.name]+'.json',null,(data)=>{
            this.$echarts.registerMap('HK', data.data)
            //判断是不是直辖市
            var d = [];
            var arr=data.data
            for( var i=0;i<arr.features.length;i++ ){
              d.push({
                name:arr.features[i].properties.name
              })
            }
            setTimeout(() => {
              this.mydata = this.$store.state.mapData
              //重新绘制
              this.renderMap(param.name,d)
            }, 300)
          })
          //控制右边比例和预警数据
          // this.allNumb=res.result
          // 存储预警机具监管总数
          var subSum = res.result.totalOne + res.result.totalTwo + res.result.totalThree + res.result.totalFour
          this.$store.commit('subSum', subSum)
          this.bus.$emit("subSum", subSum);
          this.WarData.push(res.result.totalOne)
          this.WarData.push(res.result.totalTwo)
          this.WarData.push(res.result.totalThree)
          this.WarData.push(res.result.totalFour)
          this.getWarning()
          // this.clickMap()
        },(err)=>{

        })
        this.init();
        this.getWarning();//无数据时条形图
        this.countNjNum()
        this.getworkWarningSettings()
      // this.getDevice();//无数据条形图
      /*this.getDevicedata()*/;//有数据环状图，环状图
    },
    destroyed(){
      window.removeEventListener("resize",this.init,30)
    },
    beforeDestroy(){
      //释放echars
      /*chart.clear()*/
      // this.myChart.dispose()
      // this.DeviceChart.dispose()
      // this.WarningChart.dispose()
      this.bus.$off('statue');
      this.myChart=null
      this.DeviceChart=null
      this.WarningChart=null
    },
    methods: {
      // 农机数量统计(未上报/已上报)
      countNjNum (code, prov) {
        // var areaNames = this.$store.state.areaName.substring(0,this.$store.state.areaName.length-1)
        // var areaNames = this.$store.state.areaName
        // 先判断首次请求那个层级数据
        // if(areaNames ==='上海市'||areaNames==='北京市'||areaNames==='青岛市' || areaNames === '济南市' || areaNames==='天津市'||areaNames==='重庆市'||areaNames==='台湾') {
        //   if (code === undefined || code === '') {
        //     var param = {
        //       provCode: this.$store.state.Code
        //     }
        //   } else {
        //     var param = {
        //       countyCode: code
        //     }
        //   }
        // } else if (areaNames === '青岛市' || areaNames === '济南市') {
        //   if (code === undefined || code === '') {
        //     var param = {
        //       cityCode: this.$store.state.Code
        //     }
        //   } else {
        //     var param = {
        //       countyCode: code
        //     }
        //   }
        // } else {
        //   if (this.$store.state.areaName === '全国') {
        //     if (prov !== undefined) {
        //       var param = {
        //         provCode: code
        //       }
        //     } else {
        //       var param = {
        //         countyCode: code
        //       }
        //     }
        //   } else {
        //     if (code === undefined || code === '') {
        //       var param = {
        //         provCode: this.$store.state.Code
        //       }
        //     } else {
        //       var param = {
        //         countyCode: code
        //       }
        //     }
        //   }
        // }
        if (this.$store.state.Code === '11') {
          var param = {
            provCode: this.$store.state.Code
          }
        } else {
          var param = {
            countyCode: this.$store.state.Code
          }
        }
        var url=Http.test+'/applicationSubsidy/countNjNum'
        Api.doPost(url,null,false,(res)=>{
          this.allNumb = res.result
          this.getDevice()
        })
      },
      init(){
        setTimeout(()=>{
          /*//不走缓存不需要 
          this.myChart.resize();
          this.DeviceChart.resize();
          this.WarningChart.resize();*/
          window.addEventListener("resize",()=>{
            this.myChart.resize();
            this.DeviceChart.resize();
            this.WarningChart.resize();
          })
        },30)
      },
      //查询作业预警农机阶段亩数设置
      getworkWarningSettings(){
        var parmse = {
          areaCode: this.$store.state.Code,
          level: 1
        }
        var url=Http.test+'/applicationSubsidy/warnAreaOfLevel'
        Api.doPost(url,null,false,(res)=>{
          this.WarningSetData=res.result
          this.level_1=this.WarningSetData.level_1
          this.level_2=this.WarningSetData.level_2
          this.level_3=this.WarningSetData.level_3
          this.level_4=this.WarningSetData.level_4
        },(doError)=>{

        })
      },
      //请求全省数据
      getdata(){
        var url=Http.test+'/applicationSubsidy/countWarnNjNum'
        this.WarData=[];
        Api.doPost(url,null,false,(res)=>{
          // this.mydata=res.result.mapList
          this.drawLine()
          // this.allNumb=res.result
          this.WarData.push(res.result.totalOne)
          this.WarData.push(res.result.totalTwo)
          this.WarData.push(res.result.totalThree)
          this.WarData.push(res.result.totalFour)
          this.getDevice()
          this.getWarning()
        },(err)=>{
          console.log("err")
        })
      },
      //根据层级请求数据
      Indexdata(){
        var url=Http.test+'/applicationSubsidy/countWarnNjNum'
        this.WarData=[];
        Api.doPost(url,null,false,(res)=>{
          // this.mydata=res.result.mapList
          this.drawLine()
          // this.allNumb=res.result
          this.WarData.push(res.result.totalOne)
          this.WarData.push(res.result.totalTwo)
          this.WarData.push(res.result.totalThree)
          this.WarData.push(res.result.totalFour)
          this.getDevice()
          this.getWarning()
        },(err)=>{
          console.log("err")
        })
      },
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
        this.myChart.clear()
        this.myChart.off('click')
        // 绘制图表
        this.WarData=[]
        this.myChart.setOption({
          title: {
            // text: '农机数据地图分布',
            text: '',
            color:'#ffffff',
            subtext: '',
            x:'center',
            textStyle:{
              //文字颜色
              color:'#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle:'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight:'bold',
              //字体系列
              fontFamily:'sans-serif',
              //字体大小
              fontSize:18,
            }
          },
          tooltip : {
            trigger: 'item'
          },
          //左侧小导航图标
          visualMap: {
            show : true,
            x: 'left',
            y: 'bottom',
            top:'300',
            text:['高','低'],
            padding:[5, 0 ,0, 20],
            color: ['#0360a5','#98e8ff',],//实例渐变色
            textStyle:{
              //文字颜色
              color:'#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle:'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight:'bold',
              //字体系列
              fontFamily:'sans-serif',
              //字体大小
              fontSize:16
            }
          },
          series: [{
            name:'',
            type: 'map',
            mapType: 'china',
            zoom: 1.21,
            roam: false,
            label: {
              normal: {
                show:true //省份名称
              },
              emphasis: {
                show: false
              }
            },
            data:this.mydata, //数据
            itemStyle: {
              normal: {
                areaColor: '#c9f0f7',
                borderColor: 'dodgerblue'
              },
            },
          }],
        });
        this.WarData=[]
        // var areaNames = this.$store.state.areaName.substring(0,this.$store.state.areaName.length-1)
        // if (areaNames ==='上海'||areaNames==='北京'||areaNames==='天津'||areaNames==='重庆'||areaNames==='香港'||areaNames==='澳门'||areaNames==='台湾') {
        //   return
        // } else {
          // this.clickMap()
        // }
      },
      /*地图点击方法*/
      clickMap(){
        this.WarData=[]
        //点击跳转
        this.myChart.clear()
        this.myChart.off('click');
        this.myChart.on('click', (param)=> {
          var name = param.name;
          if ( param.name in provinces ) {
            this.mydata = this.$store.state.mapData
            //请求省的热力数据
            var url=Http.test+'/applicationSubsidy/countWarnNjNum'
            var code=provinces[param.name]
            if(param.name ==='上海市'||param.name==='北京市'||param.name==='青岛市' || param.name === '济南市' || param.name==='天津市'||param.name==='重庆市'||param.name==='台湾') {
              if(this.$store.state.Index == 3){
                var data = {
                  countyCode: this.$store.state.Code
                }
              } else if (this.$store.state.Index == 1) {
                var data = {
                  provCode: code
                }
              } else {
                var data = {
                  cityCode: this.$store.state.Code,
                }
              }
              if (param.seriesName === '全国') {
                this.bus.$emit('statue',{city:'全国',key:'provName', code: code })
              } else {
                this.bus.$emit('statue',{city:code,key:'cityName'})
              }
            } else {
              var data={
                provCode:code
              }
              if (param.seriesName === '全国') {
                this.bus.$emit('statue',{city:'全国',key:'provName', code: code })
              } else {
                this.bus.$emit('statue',{city:code,key:'provName'})
              }
            }
            this.countNjNum(code, 'provCode')
            this.mydata = []
            Api.doPost(url,data,false,(res)=>{
              // this.mydata=res.result.mapList
              Api.doGet('/static/geometryProvince/'+provinces[param.name]+'.json',null,(data)=>{
                this.$echarts.registerMap('HK', data.data);
                //判断是不是直辖市
                var d = [];
                var arr=data.data
                for( var i=0;i<arr.features.length;i++ ){
                  d.push({
                    name:arr.features[i].properties.name
                  })
                }
                if (param.name === '青岛市' || param.name === '济南市') {
                  //重新绘制
                  this.mydata = this.$store.state.mapDatas
                  this.renderMap(param.name,d)
                } else {
                  //重新绘制
                  this.mydata = this.$store.state.mapDatasAll
                  this.renderMap(param.name,d)
                }
              })
              this.WarData=[]
              //控制右边比例和预警数据
              // this.allNumb=res.result
              this.WarData.push(res.result.totalOne)
              this.WarData.push(res.result.totalTwo)
              this.WarData.push(res.result.totalThree)
              this.WarData.push(res.result.totalFour)
              this.getDevice()
              this.getWarning()
            },(err)=>{
              console.log(err)
            })
          } else if ( param.seriesName in provinces ) {
            // this.mydata = []
            //如果是【直辖市/特别行政区】只有二级下钻
            if (special.indexOf( param.seriesName ) >=0) {
              // if(this.Index==0){
              //   this.getdata()
              //   this.getworkWarningSettings()
              // }
              this.mydata = this.$store.state.mapData
              this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
              Api.doGet('/static/geometryProvince/'+provinces[param.seriesName]+'.json',null,(data)=>{
                this.$echarts.registerMap('HK', data.data)
                //判断是不是直辖市
                var d = [];
                var arr=data.data
                var code = ''
                var areaNames = this.$store.state.areaName
                // 先判断首次请求那个层级数据
                if(areaNames ==='上海市' || areaNames ==='青岛市' || areaNames === '济南市') {
                  for( var i=0;i<arr.features.length;i++ ){
                    if (param.name === arr.features[i].properties.name) {
                      code = arr.features[i].properties.adcode
                    }
                  }
                } else {
                  for( var i=0;i<arr.features.length;i++ ){
                    if (param.name === arr.features[i].properties.name) {
                      code = arr.features[i].properties.id
                    }
                  }
                }
                var d = [];
                for( var i=0;i<arr.features.length;i++ ){
                  d.push({
                    name:arr.features[i].properties.name
                  })
                }
                //重新绘制
                this.renderMap(param.name,d)
                this.countyCodes = code
                this.countNjNum(code)
                var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                Api.doPost(url,{
                  countyCode: code
                },false,(res)=>{
                  // this.mydata=res.result.mapList
                  var str
                  str=this.cityName
                  /*var name=str.slice(0,-1)*/
                  var param = {
                    name: this.$store.state.areaName
                  }
                  this.WarData=[];
                  //控制右边比例和预警数据
                  // this.allNumb=res.result
                  this.WarData.push(res.result.totalOne)
                  this.WarData.push(res.result.totalTwo)
                  this.WarData.push(res.result.totalThree)
                  this.WarData.push(res.result.totalFour)
                  this.getDevice()
                  this.getWarning()
                })
                this.renderMap(areaNames, mapdata);
                if (this.$store.state.areaName === '山东省') {
                  this.mydata = this.$store.state.mapData
                  var data={
                    provCode: this.$store.state.Code
                  }
                  var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                  Api.doPost(url,data,false,(res)=>{
                    var str
                    str=this.cityName
                    var param = {
                      name: this.$store.state.areaName
                    }
                    this.bus.$emit('statue',{city:this.Code,key:'provName'})
                    this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
                    Api.doGet('/static/geometryProvince/'+provinces[param.name]+'.json',null,(data)=>{
                      this.$echarts.registerMap('HK', data.data);
                      //判断是不是直辖市
                      var d = [];
                      var arr=data.data
                      for( var i=0;i<arr.features.length;i++ ){
                        d.push({
                          name:arr.features[i].properties.name
                        })
                      }
                      var code = ''
                      for( var i=0;i<arr.features.length;i++ ){
                        if (param.name === arr.features[i].properties.name) {
                          code = arr.features[i].properties.id
                        }
                      }
                      this.countNjNum(code)
                      //重新绘制
                      this.renderMap(param.name,d)
                    })
                    // this.clickMap()
                    this.WarData=[];
                    //控制右边比例和预警数据
                    // this.allNumb=res.result
                    this.WarData.push(res.result.totalOne)
                    this.WarData.push(res.result.totalTwo)
                    this.WarData.push(res.result.totalThree)
                    this.WarData.push(res.result.totalFour)
                    this.getDevice()
                    this.getWarning()
                  },(err)=>{

                  })
                } else if (this.$store.state.areaName === '青岛市' || this.$store.state.areaName === '济南市') {
                  this.mydata = this.$store.state.mapData
                  this.renderMap(param.name,d)
                  this.bus.$emit('statue',{city:'切换',key:'provName', code: code, seriesName: param.seriesName  })
                } else {
                  this.mydata = this.$store.state.mapDatasAll
                  this.renderMap(param.name,d)
                  this.bus.$emit('statue',{city:'切换',key:'provName', code: code, seriesName: param.seriesName  })
                }
              })
            } else {
              this.mydata = []
              if (param.seriesName === '全国') {
                this.Index = 0
                if (param.name === '新疆兵团') {
                  var paramName = '新疆生产建设兵团'
                } else if (param.name === '黑龙江') {
                  var paramName = '黑龙江省'
                } else if (param.name === '西藏') {
                  var paramName = '西藏自治区'
                } else if (param.name === '新疆') {
                  var paramName = '新疆维吾尔自治区'
                } else if (param.name === '内蒙古') {
                  var paramName = '内蒙古自治区'
                } else if (param.name === '广西') {
                  var paramName = '广西壮族自治区'
                } else if (param.name === '宁夏') {
                  var paramName = '宁夏回族自治区'
                } else {
                  var paramName = param.name
                }
                Api.doGet('/static/geometryProvince/'+provinces[paramName]+'.json',null,(data)=>{
                  this.$echarts.registerMap('HK', data.data)
                  var d = [];
                  var arr=data.data
                  var code = provinces[paramName]
                  for( var i=0;i<arr.features.length;i++ ){
                    if (param.name === arr.features[i].properties.name) {
                      code = arr.features[i].properties.id
                    }
                  }
                  this.bus.$emit('statue',{city:'全国',key:'provName', code: code })    
                  this.countNjNum(code)
                  var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                  Api.doPost(url,{
                    provCode: code
                  },false,(res)=>{
                    //重新绘制
                    setTimeout(() => {
                      this.mydata = this.$store.state.mapDatasAll
                      this.renderMap(paramName,d)
                    },400)  
                    var str
                    str=this.cityName
                    var param = {
                      name: this.$store.state.areaName
                    }
                    this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
                    this.WarData=[];
                    //控制右边比例和预警数据
                    // this.allNumb=res.result
                    this.WarData.push(res.result.totalOne)
                    this.WarData.push(res.result.totalTwo)
                    this.WarData.push(res.result.totalThree)
                    this.WarData.push(res.result.totalFour)
                    this.getDevice()
                    this.getWarning()
                  })

                  // setTimeout(() => {
                  //  this.mydata = this.$store.state.mapDatasAll
                  //   this.renderMap(param.name,d)
                  // },300)
                })
              } else {
                this.mydata = []
                //显示县级地图
                //请求县城热力数据
                var xcode=cityMap[param.name]
                var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                var data={
                  cityCode:xcode
                }  
                this.bus.$emit('statue',{city:xcode,key:'cityName'})
                Api.doPost(url,data,false,(res)=>{
                  // this.mydata=res.result.mapList
                  // setTimeout(() => {
                    this.mydata = this.$store.state.mapDatas
                  // }, 300)
                  this.statue=true
                  Api.doGet('/static/city/'+cityMap[param.name]+'.json',null,(data)=>{
                    this.$echarts.registerMap('HK', data.data);
                    //判断是不是直辖市
                    var d = [];
                    var arr=data.data
                    for( var i=0;i<arr.features.length;i++ ){
                      d.push({
                        name:arr.features[i].properties.name
                      })
                    }
                    this.countNjNum(xcode)
                    this.renderMap(param.name,d)
                  })
                  this.WarData=[];
                  //控制右边比例和预警数据
                  // this.allNumb=res.result
                  this.WarData.push(res.result.totalOne)
                  this.WarData.push(res.result.totalTwo)
                  this.WarData.push(res.result.totalThree)
                  this.WarData.push(res.result.totalFour)
                  this.getDevice()
                  this.getWarning()
                },(err)=>{

                })
              }
            }
          } else {
            this.mydata = this.$store.state.mapData
            var xcode=cityMap[param.name]
            if (this.Index==0) { //层级==0或者点击县级 返回全国
              // this.getdata()
              this.Index = 2
              this.mydata = []
              this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
              Api.doGet('/static/city/'+cityMap[param.name]+'.json',null,(data)=>{
                this.$echarts.registerMap('HK', data.data);
                //判断是不是直辖市
                var d = [];
                var arr=data.data
                for( var i=0;i<arr.features.length;i++ ){
                  d.push({
                    name:arr.features[i].properties.name
                  })
                }
                this.bus.$emit('statue',{city:'全国',key:'cityName', code: xcode })
                // this.countNjNum(xcode)
                setTimeout(() => {
                  this.mydata = this.$store.state.mapDatasAll
                  this.renderMap(param.name,d)
                },300)
                var param = {
                  cityCode: xcode
                }
                var url=Http.test+'/applicationSubsidy/countNjNum'
                Api.doPost(url,null,false,(res)=>{
                  this.allNumb = res.result
                  this.getDevice()
                })
                var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                Api.doPost(url,null,false,(res)=>{
                  this.WarData=[];
                  //控制右边比例和预警数据
                  // this.allNumb=res.result
                  this.WarData.push(res.result.totalOne)
                  this.WarData.push(res.result.totalTwo)
                  this.WarData.push(res.result.totalThree)
                  this.WarData.push(res.result.totalFour)
                  this.getDevice()
                  this.getWarning()
                })
                //重新绘制
                this.renderMap(param.name,d)
                
              })
            } else if (this.Index==1){
              this.mydata = this.$store.state.mapData
              if (this.$store.state.areaName === '青岛市' || this.$store.state.areaName === '济南市') {
                var data={
                  cityCode: this.$store.state.Code
                }
              } else {
                var data={
                  provCode: this.$store.state.Code
                }
              }
              var url=Http.test+'/applicationSubsidy/countWarnNjNum'
              Api.doPost(url,data,false,(res)=>{
                // this.mydata=res.result.mapList
                var str
                str=this.cityName
                // if (this.$store.state.areaName === '新疆生产建设兵团' || this.$store.state.areaName === '宁夏回族自治区') {
                  var param = {
                    name: this.$store.state.areaName
                  }
                // } else {
                //   var param = {
                //     name: this.$store.state.areaName.substring(0,this.$store.state.areaName.length-1)
                //   }
                // }
                this.bus.$emit('statue',{city:this.Code,key:'provName'})
                this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
                Api.doGet('/static/geometryProvince/'+provinces[param.name]+'.json',null,(data)=>{
                  this.$echarts.registerMap('HK', data.data);
                  //判断是不是直辖市
                  var d = [];
                  var arr=data.data
                  for( var i=0;i<arr.features.length;i++ ){
                    d.push({
                      name:arr.features[i].properties.name
                    })
                  }
                  var code = ''
                  for( var i=0;i<arr.features.length;i++ ){
                    if (param.name === arr.features[i].properties.name) {
                      code = arr.features[i].properties.id
                    }
                  }
                  this.countNjNum(code)
                  //重新绘制
                  this.renderMap(param.name,d)
                })
                // this.clickMap()
                this.WarData=[];
                //控制右边比例和预警数据
                // this.allNumb=res.result
                this.WarData.push(res.result.totalOne)
                this.WarData.push(res.result.totalTwo)
                this.WarData.push(res.result.totalThree)
                this.WarData.push(res.result.totalFour)
                this.getDevice()
                this.getWarning()
              },(err)=>{

              })
            } else if (this.Index==2) {
              this.mydata = this.$store.state.mapData
              this.bus.$emit('statue',{city:'全国',key:'provMap', code: '' })
              this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
              var paramMap = {
                name: this.$store.state.areaName
              }
              Api.doGet('/static/geometryProvince/'+provinces[paramMap.name]+'.json',null,(data)=>{
                this.$echarts.registerMap('HK', data.data)
                //判断是不是直辖市
                var d = [];
                var arr=data.data
                for( var i=0;i<arr.features.length;i++ ){
                  d.push({
                    name:arr.features[i].properties.name
                  })
                }
                this.Index = 3
                // this.countNjNum(xcode)
                setTimeout(() => {
                  this.renderMap(paramMap.name,d)
                },400)
                var param = {
                  provCode: ''
                }
                var url=Http.test+'/applicationSubsidy/countNjNum'
                Api.doPost(url,null,false,(res)=>{
                  this.allNumb = res.result
                  this.getDevice()
                })
                var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                Api.doPost(url,param,false,(res)=>{
                  this.WarData=[];
                  //控制右边比例和预警数据
                  // this.allNumb=res.result
                  this.WarData.push(res.result.totalOne)
                  this.WarData.push(res.result.totalTwo)
                  this.WarData.push(res.result.totalThree)
                  this.WarData.push(res.result.totalFour)
                  this.getDevice()
                  this.getWarning()
                })
                //重新绘制
                this.renderMap(param.name,d)
              })
            } else if (this.Index==3) {
              this.mydata = []
              this.Index = 0
              var paramName = param.name
              Api.doGet('/static/geometryProvince/'+provinces[paramName]+'.json',null,(data)=>{
                this.$echarts.registerMap('HK', data.data)
                var d = [];
                var arr=data.data
                var code = provinces[paramName]
                for( var i=0;i<arr.features.length;i++ ){
                  if (param.name === arr.features[i].properties.name) {
                    code = arr.features[i].properties.id
                  }
                }
                this.bus.$emit('statue',{city:'全国',key:'provName', code: code })
                //重新绘制
                setTimeout(() => {
                  this.mydata = this.$store.state.mapDatasAll
                  this.renderMap(param.name,d)
                },300)      
                this.countNjNum(code)
                var url=Http.test+'/applicationSubsidy/countWarnNjNum'
                Api.doPost(url,{
                  provCode: code
                },false,(res)=>{
                  var str
                  str=this.cityName
                  var param = {
                    name: this.$store.state.areaName
                  }
                  this.myChart = this.$echarts.init(document.getElementById('myChartItem'))
                  this.WarData=[];
                  //控制右边比例和预警数据
                  // this.allNumb=res.result
                  this.WarData.push(res.result.totalOne)
                  this.WarData.push(res.result.totalTwo)
                  this.WarData.push(res.result.totalThree)
                  this.WarData.push(res.result.totalFour)
                  this.getDevice()
                  this.getWarning()
                })
              })
            }
          }
        })
      },
      // 重绘地图
      renderMap(d){
        this.myChart.setOption({
          title: {
            text: '',
            color:'#ffffff',
            fontWeight:'bold',
            subtext: '',
            x:'center'
          },
          tooltip : {
            trigger: 'item'
          },
          // 左侧小导航
          visualMap: {
            show : false,
            x: 'left',
            y: 'bottom',
            text:['高','低'],
            color: ['#0360a5','#98e8ff',],//实例渐变色
            textStyle:{
              //文字颜色
              color:'#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle:'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight:'bold',
              //字体系列
              fontFamily:'sans-serif',
              //字体大小
              fontSize:16
            },
            calculable: true
          },
          geo3D: {
            show: true,
            map: 'HK',
            roam: true
          },
          // 配置属性
          series: [{
            name: d,
            type: 'map',
            mapType: 'HK',
            top: 50,
            zoom: 1.21,
            // roam: false,
            regionHeight: 2,
            viewControl: {
              autoRotate: false,
              distance: 70
            },
            label: {
              normal: {
                show: true // 省份名称
              },
              emphasis: {
                show: false
              }
            },
            data:this.mydata, // 数据
            itemStyle: {
              normal: {
                areaColor: '#c9f0f7',
                borderColor: 'dodgerblue'
              }
            }
          }]
        })
      },
      // 右边环状
      // 空闲比例
      getDevice(){
        this.DeviceChart = this.$echarts.init(document.getElementById('DeviceChart'))
        this.DeviceChart.setOption({
          // backgroundColor: '#0B1640',
          calculable:true,
          title: {
            // text: '物联网农机设备状态比例',
            subtext: '',
            color:'#ffffff',
            textStyle:{
              //文字颜色
              color:'#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle:'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight:'normal',
              //字体系列
              fontFamily:'sans-serif',
              //字体大小
              fontSize:18
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          grid: {
            top: '10%',    //距离容器上边界40像素
            bottom: '1%',  //距离容器下边界30像素
            left:'10%',
            right:'10%',
            containLabel: true
          },
          color:['#9d5cff','#60CAF1','#9d5cff'],
          series: [
            {
              name:'',
              type:'pie',
              radius: ['30%', '77%'],
              avoidLabelOverlap: true,//是否启用防止标签重叠策略，默认默认开启
              labelLine: {
                normal: {
                  show: true,//显示折线
                }
              },
              label: {
                show: true,
                color: '#fff'
                // precision: 1,
                // position: "right",
              },
              data:[
                {value:this.allNumb.notSendData, name:'未上报过数据'},
                {value:this.allNumb.sendData, name:'已上报过数据'}
                // {value:this.allNumb.noStatus, name:'未上报过数据'},
                // {value:this.allNumb.noStatusProportion, name:'无数据农机比例'},
              ]
            }
          ]
        })
        this.DeviceChart.off();
        this.DeviceChart.on('click', (param)=> {
          if(param.data.name==='未上报过数据'){
            var url=Http.test+'/homePage/exportNoDataNjInfo'
            if(this.$store.state.Index == 1){
              var parames = {
                provCode: this.Code,
                // areaLevel:this.$store.state.Index
              }
            }else if(this.$store.state.Index == 2){
              var parames = {
                cityCode: this.Code,
                // areaLevel:this.$store.state.Index
              }
            }else{
              var parames = {
                countyCode: this.Code,
                // areaLevel:this.$store.state.Index
              }
            }
            // Api.downloadFile(url,,'application/vnd.ms-excel;charset=UTF-8',(res)=>{
            //   alert('ok ')
            // },(err)=>{
            //   console.log("err")
            // })
            // Api.downloadFile(url, '导出数据.xls', 'application/vnd.ms-excel;charset=UTF-8', parames)
            Api.downloadFile(url, '未上报数据导出表.xls', 'application/vnd.ms-excel;charset=UTF-8', parames)
          }
        })
      },
      // 预警农机比例
      getWarning(){
        this.WarningChart = this.$echarts.init(document.getElementById('WarningChart'))
        var seriesLabel = {
          normal: {
            show: true,
            textBorderColor: '#333',
            textBorderWidth: 2
          }
        }
        this.WarningChart.setOption({
          // backgroundColor: '#0B1640',
          title: {
            // text: '预警农机（累计数据）',
            subtext: '',
            color:'#ffffff',
            textStyle:{
              //文字颜色
              color:'#ffffff',
              //字体风格,'normal','italic','oblique'
              fontStyle:'normal',
              //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
              fontWeight:'normal',
              //字体系列
              fontFamily:'sans-serif',
              //字体大小
              fontSize:18
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top:'18%',
            left: '5%',
            right: '4%',
            bottom: '-0%',
            containLabel: true
          },
          xAxis: {
            splitLine:{
              show:false
            },
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
          },
          yAxis: {
            splitLine:{
              show:false
            },
            type: 'category',
            // name: '预警面积（亩）',
            nameLocation:'center',
            nameTextStyle:{
              color: '#60CAF1',
              fontSize:14
              // padding:15,
            },
            nameStyle:{
              //文字颜色
              color:'#75C3FF',
            },
            // data: ['0','0-20','20-50','50-100',],
            data: [this.level_1,this.level_2,this.level_3,this.level_4,],
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            //去掉刻度线
            axisTick: {
              show: false
            },
          },
          series: [
            {
              name: '',
              type: 'bar',
              barWidth: 25,
              label: {//Y坐标数值显示；
                color: "#fff",
                show: true,
                position: "right",
                // seriesLabel
              },
              data:this.WarData,
              itemStyle: {
                normal: {
                  //通过数组下标选择颜色
                  color: function(params) {
                    var colorList = [
                      '#a20602','#ce280d','#e45f31', '#f8b565',,
                    ];
                    return colorList[params.dataIndex]
                  },
                }
              }
            }
          ]
        })
      }
    }
  }
</script>
<style>
.homeEcharts{
  width:100%;
  height: 100%;
  overflow:hidden;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
}
#myChartItem{
  width:56%;
  height:100%;
  float: left;
}
.echarts-left{
  width:44%;
  height: 100%;
  float: left;
}
  .backColor{
    width: 100%;
    height:50%;
    padding: 5px;
    box-sizing: border-box;
    background: url("/static/img/right-bg.png")no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .left-ztbl{
    position: absolute;
    left: 10px;
    top: 12px;
    z-index: 100;
    color: #fff;
    font-size: 18px;
  }
  .backColorbotom{
    width:100%;
    height: 25.5vh;
    margin-top: 1vh;
    background: url("/static/img/right-bot.png")no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .left-yjmj{
    position: absolute;
    left: 10px;
    top: 7vh;
    z-index: 100;
    width: 18px;
    color: #75C3FF;
    font-size: 14px;
  }
  #DeviceChart{
    width:100%;
    height: 20vh;
    margin-top: 5vh;
  }
  #WarningChart{
    width:100%;
    height: 23vh;
    padding: 0px 10px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/Subsidies/common/Eachars.vue